const ProjectCard = ({ project, onOpen, label, viewLabel }) => (
  <button
    type="button"
    className="proyectos__card"
    onClick={() => onOpen(project)}
    aria-label={label}
  >
    <div className="proyectos__card-media">
      <img
        src={project.image}
        alt=""
        aria-hidden="true"
        className="proyectos__card-image"
        loading="lazy"
        decoding="async"
      />
      <span className="proyectos__card-veil" aria-hidden="true" />
      <img
        src={project.logo}
        alt={project.name}
        className="proyectos__card-logo"
        loading="lazy"
        decoding="async"
      />
    </div>
    <div className="proyectos__card-meta">
      <span className="proyectos__card-name">{project.name}</span>
      {viewLabel && (
        <span className="proyectos__card-cta" aria-hidden="true">
          {viewLabel}
          <svg viewBox="0 0 14 10" width="14" height="10" focusable="false">
            <path
              d="M0 5h12M8 1l4 4-4 4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="square"
            />
          </svg>
        </span>
      )}
    </div>
  </button>
);

export default ProjectCard;
